import { PEQuestionnaire } from '../../../../../lib/Questionnaires'
import {
  RadioGroupInput,
  CheckboxInput,
  TextInput
} from '../../../../shared/FormBuilder'

function Psychiatric () {
  return (
    <div className='form-section'>
      <div className='row'>
        <div className='col-xs-offset-1 col-xs-4 nh-sub-head'>Normal</div>
        <div className='col-xs-6 nh-sub-head'>Abnormal</div>
      </div>
      <div className='row'>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.mentalhealthAlertness.name}
            options={[
              {
                label: 'Alert',
                value: 'Alert'
              },
              {
                label: 'Lethargic',
                value: 'Lethargic'
              }
            ]}
          />
        </div>

        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.mentalhealthOrientation.name}
            options={[
              {
                label: 'Oriented',
                value: 'Oriented'
              },
              {
                label: 'Confused',
                value: 'Confused'
              }
            ]}
          />
        </div>

        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.mentalhealthAffect.name}
            options={[
              {
                label: 'Appropriate Affect',
                value: 'Appropriate Affect'
              },
              {
                label: 'Withdrawn',
                value: 'Withdrawn'
              },
              {
                label: 'Manic',
                value: 'Manic'
              }
            ]}
          />
        </div>
        <div className='col-xs-12 margin-top'>
          <CheckboxInput {...PEQuestionnaire.mentalhealthOther} />
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12'>
          <TextInput {...PEQuestionnaire.mentalhealthOtherText} />
        </div>
      </div>
    </div>
  )
}

export default Psychiatric
